<template>
  <b-modal
    v-model="showModal"
    centered
    size="lg"
    header-class="custom-modal-header"
    hide-footer
  >
    <template #modal-header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <p>CHANNEL LIST</p>
        <div class="d-flex w-75">
          <b-input-group class="w-100 mr-2">
            <b-form-input
              v-model="filter.search"
              placeholder="Search Name"
              @keydown.enter="handleSearch"
            />
            <b-input-group-append>
              <b-button @click="handleSearch" class="search-button">
                <font-awesome-icon icon="search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <button
            type="button"
            aria-label="Close"
            class="btn p-0"
            @click="onCloseModal"
          >
            <font-awesome-icon icon="times" title="Delete" />
          </button>
        </div>
      </div>
    </template>
    <b-table
      responsive
      striped
      hover
      class="table-list"
      :items="itemsDisplay"
      :fields="fields"
      :busy="isBusy"
      show-empty
      :empty-text="$t('noData')"
      :current-page="filter.pageNo"
      :per-page="filter.perPage"
    >
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(id)="data">
        <div class="d-flex justify-content-center">
          <button
            type="button"
            @click="onSubmit(data.item)"
            :disabled="isDisabled"
            class="btn btn-main"
          >
            Select
          </button>
        </div>
      </template>

      <template v-slot:cell(platformConfigId)="data">
        <div class="tag-social">
          <img :src="data.item.imageUrl" alt="" />
          <span class="mb-0">{{ data.item.name }}</span>
        </div>
      </template>
    </b-table>
    <b-row class="no-gutters px-3 px-sm-0">
      <b-col
        class="form-inline justify-content-center justify-content-sm-between"
      >
        <div v-if="rows > 0" class="my-auto">
          Showing {{ startPage | numeral("0,0") }} to
          {{ endPage | numeral("0,0") }} of {{ rows | numeral("0,0") }} entires
        </div>
        <div v-else class="my-auto">{{ rows || 0 }} entire</div>
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="filter.pageNo"
            :total-rows="rows"
            :per-page="filter.perPage"
            class="m-md-0"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";

export default {
  name: "ModalChannel",
  components: {
    InputText,
  },
  props: {
    id: {
      required: true,
      type: [String, Number],
      default: "",
    },
  },
  data: function () {
    return {
      showModal: false,
      isDisabled: false,
      rows: 0,
      filter: {
        search: "",
        pageNo: 1,
        perPage: 5,
      },
      startPage: 1,
      endPage: 5,
      fields: [
        {
          key: "id",
          label: "",
          class: "w-action",
        },
        {
          key: "platformConfigId",
          label: "Channel",
          tdClass: "text-center",
        },
      ],
      isBusy: false,
      itemsDisplay: [],
      items: [],
      form: {
        platformconfigId: "",
        id: "",
      },
    };
  },
  methods: {
    onShowModal: async function () {
      this.filter.search = "",
      this.filter.pageNo = 1;
      await this.getAllPlatformConfig();
      this.showModal = true;
    },
    handleSearch() {
      let search = this.filter.search.toLowerCase();
      let filtered = this.items.filter((ele) =>
        `${ele.name.toLowerCase()}`.includes(search)
      );
      this.itemsDisplay = filtered;
      this.rows = this.itemsDisplay.length;
      this.filter.pageNo = 1;
    },
    onCloseModal() {
      this.clearFilter();
      this.showModal = false;
    },
    pagination(page) {
      this.filter.pageNo = page;
      this.getShowingPage(page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    clearFilter() {
      this.filter = {
        search: "",
        pageNo: 1,
        perPage: 5,
      };
    },
    getAllPlatformConfig: async function () {
      await this.axios
        .get(`${this.$baseUrl}/TeamAssign/ListChannel`)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail;
            this.itemsDisplay = data.detail;
            this.rows = this.itemsDisplay.length;
          }
        });
    },
    onSubmit: async function (item) {
      this.isDisabled = true;
      this.form.platformconfigId = item.platformConfigId;
      this.form.id = this.id;
      await this.axios
        .post(
          `${this.$baseUrl}/TeamAssign/AddChannel/${this.form.platformconfigId}/${this.form.id}`,
          {}
        )
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            this.$emit("reloadData");
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.detail,
            });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });

      setTimeout(() => {
        this.isDisabled = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-main {
  min-width: 0 !important;
}
</style>
